import { useState, useEffect } from 'react';

/**
 * Tracks window.visualViewport so mobile layouts can adapt
 * when the on-screen keyboard opens or closes.
 *
 * Returns { height, offsetTop } from the visual viewport.
 * - height: visible viewport height (shrinks when keyboard opens)
 * - offsetTop: distance the visual viewport has scrolled from the
 *   layout viewport top (increases when keyboard pushes content up)
 *
 * Falls back to window.innerHeight / 0 for browsers without support.
 */
const useVisualViewport = () => {
  const [viewport, setViewport] = useState(() => ({
    height: window.visualViewport?.height ?? window.innerHeight,
    offsetTop: window.visualViewport?.offsetTop ?? 0,
  }));

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const update = () => {
      setViewport({ height: vv.height, offsetTop: vv.offsetTop });
    };

    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);

  return viewport;
};

export default useVisualViewport;
